module.exports = __webpack_public_path__ + "static/light-dark-83b2128291d8da448d1b7bb408932a69.svg";